// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"Q6P9gHxeM3lUdwu8_U-ms","shareTitle":"eG8930Kk9Hn7tCZMdGPi","articleSocialIcons":"_2xd9gAGthLOsvbw65HDBjU","shareRow":"xxhW8_Xa6A8luS1UfQatc","shareIcon":"_3wlJ1y_KzFBBNgFQlbt-O5","iconWrapper":"_2hW7X3CiUYW_sCZXhatw7k","copyLinkWrap":"_1-Qd7zlKzJn3wCItv1ehbt","copyLink":"_1q9oiURJCKukOzq1hKg-i_","companySocialIcons":"_2CDjEnfZvK5OLCEhQJ4rG5"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ShareArticleButtons/ShareActicleButtons.scss
// module id = 1748
// module chunks = 0